module.exports = __webpack_public_path__ + "static/media/N6.a1e797fc.png";